import { IQuantity, Quantity } from "../../../common/models/quantity.model";
import i18next from "i18next";

export const generateItems = (
  quantity: IQuantity,
  actions: any,
  selectedUnactiveUser: any,
  activatedUsers: any
) => {
  const t = i18next.getFixedT(null, "admin");
  switch (quantity) {
    case Quantity.NONE:
        return [

          ];
    case Quantity.ONE:
      if (selectedUnactiveUser && activatedUsers[selectedUnactiveUser.id]) {
        return [

        ];
      } else {

        return [
          {
            key: "activate",
            text: t("nav.activate"),
            iconProps: { iconName: "ReminderPerson" },
            onClick: actions.activateUserById,
          }
        ];
      }

    default:
      return [];
  }
};
